import * as eventSettings from './event-settings';
import * as events from './events';
import * as changelog from './changelog';
import * as eventTriggerSetting from './event-trigger-setting';

export default { eventSettings, events, changelog, eventTriggerSetting };
